"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NULL_ADDRESS = exports.NULL_BYTES = void 0;
exports.NULL_BYTES = '0x';
exports.NULL_ADDRESS = '0x0000000000000000000000000000000000000000';
